/**
 * Attendance feature — UI-only presentation settings (three-bucket).
 *
 * Status palette + labels rendered by the per-row status selector.
 * Backed by ``AttendanceStatus`` literal from the generated API types,
 * which itself derives from ``app/features/attendance/config/rules.py``.
 */

import type { AttendanceStatus } from '../api/attendance';

export interface StatusOption {
  value: AttendanceStatus;
  label: string;
  color: string;
  consumes: boolean;
}

/** Authoritative UI options. ``consumes`` is purely informational here —
 *  the backend is the only place that actually debits an entitlement. */
export const ATTENDANCE_STATUS_OPTIONS: readonly StatusOption[] = [
  { value: 'present', label: 'Present', color: '#16a34a', consumes: true },
  { value: 'absent', label: 'Absent', color: '#dc2626', consumes: false },
  { value: 'late', label: 'Late', color: '#f59e0b', consumes: true },
  { value: 'excused', label: 'Excused', color: '#64748b', consumes: false },
  { value: 'makeup', label: 'Make-up', color: '#7c3aed', consumes: true },
] as const;

export const ATTENDANCE_UI = {
  STATUS_OPTIONS: ATTENDANCE_STATUS_OPTIONS,
} as const;

